"use client";
import { useCallback, useState } from "react";

import { Image } from "@/components/displays";

import { Ingredients, IngredientsProps } from "./Ingredients";
import { Instructions, InstructionsProps } from "./Instructions";
import styles from "./Recipe.module.scss";

export interface RecipeProps {
  image: {
    title?: string;
    subTitle?: string;
    src: string;
    alt?: string;
  };
  ingredientSubTitle?: string;
  ingredients: IngredientsProps["ingredients"];
  instructions: InstructionsProps["instructions"];
  detailsHidable?: boolean;
}

export function Recipe({
  image,
  ingredientSubTitle,
  ingredients,
  instructions,
  detailsHidable = false,
}: RecipeProps): React.ReactNode {
  const [showRecipe, setShowRecipe] = useState(!detailsHidable);

  const toggleRecipe = useCallback(() => {
    setShowRecipe((prev) => !prev);
  }, []);

  return (
    <>
      {image.title && (
        <p className="text__l text__bold mg__bottom__m">
          {image.title}
          {image.subTitle && (
            <span className="text__s text__bold text__gray__dark">{image.subTitle}</span>
          )}
        </p>
      )}
      <Image
        src={image.src}
        alt={image.title || image.alt || "Recipe Image"}
        className="mg__bottom__m"
        width={334}
        height={188}
      />
      {showRecipe && (
        <div className={styles.detailsContainer}>
          <div className="col-12 col-m-6 md__bottom__l">
            <Ingredients subTitle={ingredientSubTitle} ingredients={ingredients} />
          </div>
          <div className="col-12 col-m-6">
            <Instructions instructions={instructions} />
          </div>
        </div>
      )}
      {detailsHidable && (
        <div className="col-12 text__center pd__bottom__m">
          <button
            type="button"
            className="btn inline border__bk round text__m"
            onClick={toggleRecipe}
          >
            {showRecipe ? "レシピを閉じる" : "レシピを表示"}
          </button>
        </div>
      )}
    </>
  );
}
